import { render } from "./ReturnReason.vue?vue&type=template&id=e493afae&scoped=true"
import script from "./ReturnReason.vue?vue&type=script&lang=js"
export * from "./ReturnReason.vue?vue&type=script&lang=js"

import "./ReturnReason.vue?vue&type=style&index=0&id=e493afae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e493afae"]])

export default __exports__